import { useQuery } from '@tanstack/react-query'
import request from 'api'

const QUERY_KEYS = ['/services/3rdParties']

type ConnectedServiceResponse = {
  clientId: string
  imageUrl: string
  aliasName: string
  scope: string[]
  searchConditions: string[]
}

export type LinkedService = {
  applicationId: string
  displayName: string
  iconUrl: string
  scopes: string[]
  searchConditions: string[]
}

const fetcher = async () => {
  const connectedServiceResponses = await request
    .get<ConnectedServiceResponse[]>(`/v1/services/3rdParties`)
    .then((res) => res.data)
    .catch(() => [] as ConnectedServiceResponse[])
  return connectedServiceResponses.map((connectedService) => {
    const iconUrl = connectedService.imageUrl
      ? connectedService.imageUrl.startsWith('http')
        ? connectedService.imageUrl
        : process.env.REACT_APP_LEGACY_HOST + '/membership/mbr/en_US/front' + connectedService.imageUrl
      : process.env.REACT_APP_LEGACY_HOST + '/membership/assets/images/layout/icon_noconnected01.png'

    return {
      applicationId: connectedService.clientId,
      displayName: connectedService.aliasName,
      iconUrl: iconUrl,
      scopes: connectedService.scope,
      searchConditions: connectedService.searchConditions
    } as LinkedService
  })
}

const useLinkedServicesQuery = () => useQuery(QUERY_KEYS, fetcher)

export default useLinkedServicesQuery
